import { useTranslation } from 'react-i18next';
import Page from '@/components/Page';
import Amir from '@/assets/images/team/amir.jpg';
import Adi from '@/assets/images/team/adi.jpg';
import Guy from '@/assets/images/team/guy.jpg';
import Itzik from '@/assets/images/team/itzik.jpg';
import Max from '@/assets/images/team/max.jpg';
import Omer from '@/assets/images/team/omer.jpg';
import Shoshana from '@/assets/images/team/shoshana.jpg';
import Vadim from '@/assets/images/team/vadim.jpg';
import Yael from '@/assets/images/team/yael.jpg';
import GroupDisplay from '@/components/GroupDisplay';
import MemberCard from '@/components/MemberCard';
import classes from './team.module.css';

const Team = () => {
  const { t } = useTranslation();

  const members = [
    {
      img: Amir,
      name: t('pages.team.members.amir.name'),
      position: t('pages.team.members.amir.position'),
      description: t('pages.team.members.amir.description'),
    },
    {
      img: Vadim,
      name: t('pages.team.members.vadim.name'),
      position: t('pages.team.members.vadim.position'),
      description: t('pages.team.members.vadim.description'),
    },
    {
      img: Omer,
      name: t('pages.team.members.omer.name'),
      position: t('pages.team.members.omer.position'),
      description: t('pages.team.members.omer.description'),
    },
    {
      img: Max,
      name: t('pages.team.members.max.name'),
      position: t('pages.team.members.max.position'),
      description: t('pages.team.members.max.description'),
    },
    {
      img: Itzik,
      name: t('pages.team.members.itzik.name'),
      position: t('pages.team.members.itzik.position'),
      description: t('pages.team.members.itzik.description'),
    },
    {
      img: Shoshana,
      name: t('pages.team.members.shoshana.name'),
      position: t('pages.team.members.shoshana.position'),
      description: t('pages.team.members.shoshana.description'),
    },
    {
      img: Guy,
      name: t('pages.team.members.guy.name'),
      position: t('pages.team.members.guy.position'),
      description: t('pages.team.members.guy.description'),
    },
    {
      img: Adi,
      name: t('pages.team.members.adi.name'),
      position: t('pages.team.members.adi.position'),
      description: t('pages.team.members.adi.description'),
    },
    {
      img: Yael,
      name: t('pages.team.members.yael.name'),
      position: t('pages.team.members.yael.position'),
      description: t('pages.team.members.yael.description'),
    },
  ];

  const slides = members.map((member, index) => (
    <MemberCard key={member.name} {...member} id={index} />
  ));

  return (
    <Page isFull>
      <div className={classes.contents}>
        <h2 className={classes.head}>{t('pages.team.title')}</h2>
        <GroupDisplay slides={slides} />
        {/* <Carousel slides={slides} options={{ direction: 'rtl' }} /> */}
      </div>
    </Page>
  );
};

export default Team;
